function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/// <reference path="../../types.d.ts" />
import classnames from 'classnames';
import React from 'react';
import { Route } from 'react-router-dom';
import { Card } from '@codametrix/ui-components';
import { GitTag } from '../../core/git-info';
import { AdminTemplate } from '../../components/admin-template/admin-template';
import Keypress from '../../views/keypress/keypress-component';
import ContextChoiceForm from '../../views/context/context-choice-form';
import TableauDashboard from '../../views/analytics/tableau-dashboard-component';
import { default as CaseListAndDetail } from '../../views/case/case-list/case-list-and-detail-component';
// For monitoring changes to the SPA's URL so we can rename views for DataDog
import { handleLocationChange } from '../../core/middleware/analytics-middleware';
import LocationEffect from '../../core/effects/location/LocationEffect';
import { StubContext } from '../../tests/fixtures/stubs/contexts';
import { USER_STUB } from '../../tests/fixtures/stubs/user';
import { setIsActive } from '../../core/net';
import { authenticationChannel, cmxLocation, commonActions, Utils } from '@codametrix/ui-common';
import { Eula } from '../../views/eula/eula';
import ServiceLineMessage from '../../views/service-lines/service-line-message';
import { PrimaryGlobalNavigation } from '../../components/primary-global-navigation/primary-global-navigation';
import { Toast } from '../../components/toast-message/toast';
import { LogoutModal } from '../../components/logout-modal/logout-modal';
import { AccountSettings } from '../../views/account-settings/account-settings';
import { ProviderDirectoryFrame } from '../../views/provider-directory/provider-directory-frame';
import LoadingOverlay from '../../components/loader-overlay/loader-overlay';
import { ChakraProvider } from '@chakra-ui/react';
import theme from '../../theme';
import { CaseCancellationComponent } from '../components/case-cancellation-component';
import { InvoiceEditorComponent } from '../components/invoice-editor-component';
import { QueueSettings } from '../service-desk/service-desk-component';
import { PatientTimeline } from '../../views/patient-timeline/patient-timeline';
import { CMXDrawer } from '../../views/cmx-drawer/cmx-drawer';
import { ConnectedServiceDeskAndCodeBench } from '../service-desk/service-desk-and-codebench.component';
import { QualityAssessment } from '../service-desk/service-desk-component';
import { MergeCasesModal } from '../../components/merge-cases-modal/merge-cases-modal';
import { CreateCase } from '../../views/create-case/create-case';
import { AttachDocsModal } from '../../components/attach-docs-modal/attach-docs-modal';
import { ProviderDetails } from '../../views/provider-details/provider-details';
import { CapturedTime } from '../../views/time-entry/captured-time';
import { ConnectedServiceDeskAndGradeBench } from '../service-desk/service-desk-and-gradebench.component';
import { CQA_QUALITY_ASSESSMENT_GRADING_SCREEN, routedToGradingScreen } from '../../core/utils/isCQAGradingScreen';
import { CoderNotes } from '../../views/coder-notes/coder-notes';
import { BiomeIcon, IconName } from '@codametrix/verdigris';
import { SwitchingContext } from '../../views/switching-context/switching-context';
const SupportedResources = new Set([
    `power_features`,
    `case_configuration`,
    `users`,
    'dictionary'
]);
var _React_Component;
class CMx extends (_React_Component = React.Component) {
    componentDidMount() {
        this.props.onLoad({
            context: this.props.context,
            homepagePreference: this.props.homepagePreference
        });
        window.addEventListener('mousedown', this.registerActivity, false);
        window.addEventListener('keypress', this.registerActivity, false);
    }
    componentWillUnmount() {
        window.removeEventListener('mousedown', this.registerActivity, false);
        window.removeEventListener('keypress', this.registerActivity, false);
    }
    handleDismissFeedback() {
        //@ts-ignore
        this.props.dismissFeedback(this.props.feedback);
    }
    handleAdminTabSelect(item) {
        const { AdminTabs, selectAdminTab } = this.props;
        let tabs = AdminTabs.map((subAction, index)=>{
            const active = subAction.id === item.id;
            return {
                ...subAction,
                active: active
            };
        });
        selectAdminTab(item.path ? item.path : '', item, tabs);
    }
    getMaintenanceWrappedComponent(component, hasWorklistMaintenanceWindow) {
        // If maintenance flag changed, clear the cache
        if (this.cachedMaintenanceFlag !== hasWorklistMaintenanceWindow) {
            this.maintenanceWrappedComponents.clear();
            this.cachedMaintenanceFlag = hasWorklistMaintenanceWindow;
        }
        // Return cached wrapped component if it exists
        if (this.maintenanceWrappedComponents.has(component)) {
            return this.maintenanceWrappedComponents.get(component);
        }
        // Create wrapped component
        const redirectToMaintenance = ()=>{
            const currentUrl = window.location.pathname + window.location.search + window.location.hash;
            window.history.pushState({
                previousUrl: currentUrl,
                reason: 'maintenance_redirect',
                timestamp: Date.now()
            }, '', currentUrl);
            window.location.href = '/maintenance.html';
        };
        const wrappedComponent = (routeProps)=>{
            if (hasWorklistMaintenanceWindow) {
                redirectToMaintenance();
                return null;
            }
            return /*#__PURE__*/ React.createElement(component, routeProps);
        };
        // Cache and return
        this.maintenanceWrappedComponents.set(component, wrappedComponent);
        return wrappedComponent;
    }
    render() {
        const { awaitingTokenTransfer, awaitingResources, roles, loading, loadingState, feedback, actionGroups, hasResources, onSelection, contexts, context, handleOrganizationChoice, handleServiceLineChoice, modal, phiMask, activeUser, AdminTabs, serviceLine, openAccountSettings, openCapturedTime, listStatus, updateStatus, listCapturedTime, listProtectedTime, deleteProtectedTimeEntry, updateProtectedTimeEntry, addProtectedTimeEntry, getMaxAllowedBackdate, getSubNavPaths, accountSettingsIsOpen, capturedTimeIsOpen, caseLoadState, showDashboardOptions, hasWorklistMaintenanceWindow } = this.props;
        const activeMask = phiMask.available && phiMask.active;
        const styleClasses = [
            `cmx-application-chakra`,
            `layout-full`,
            `min-dimensions`,
            `max-dimensions`,
            `full-height`,
            {
                'mask-sensitive-data': activeMask
            },
            ...roles.map((role)=>`${role.roleName}-role`)
        ];
        const isNewFlow = Utils.doesPathEndWithV2();
        const atGradingScreen = routedToGradingScreen(window.location.pathname);
        let mainStyle;
        if (isNewFlow || atGradingScreen) {
            if (this.props.showSideNavBar) {
                mainStyle = {
                    top: 0,
                    marginLeft: theme.space[96]
                };
            } else {
                mainStyle = {
                    top: 0,
                    marginLeft: 0
                };
            }
        } else {
            mainStyle = {
                top: 0,
                marginLeft: theme.space[96]
            };
        }
        const noActiveContext = !loading && (!context || context.activeContext === null);
        const noEulaAcceptance = cmxLocation.getLocation() === '/eula/';
        const noRoutes = noActiveContext || noEulaAcceptance;
        if ((loading || loadingState?.isLoading) && !caseLoadState.loading) {
            styleClasses.push(`cmx-application-chakra-masked`);
        } else if (noActiveContext) {
            styleClasses.push(`cmx-application-masked cmx-application-choose-context`);
        } else {
            styleClasses.push(`cmx-application-loaded`);
        }
        const resources = context?.activeContext?.resources ?? [];
        resources.forEach((resource)=>{
            if (SupportedResources.has(resource.resourceName)) {
                styleClasses.push(`${resource.resourceName}-active`);
            }
        });
        const redirectToMaintenance = ()=>{
            const currentUrl = window.location.pathname + window.location.search + window.location.hash;
            window.history.pushState({
                previousUrl: currentUrl,
                reason: 'maintenance_redirect',
                timestamp: Date.now()
            }, '', currentUrl);
            window.location.href = '/maintenance.html';
        };
        const handleNavSelection = (originalOnSelection, isWorklistMaintenanceWindow)=>{
            return (selection)=>{
                // List of blocked navigation IDs/paths during maintenance
                const blockedPaths = [
                    'worklist/',
                    'queue-settings/',
                    'coding-quality/'
                ];
                if (isWorklistMaintenanceWindow && blockedPaths.some((path)=>selection.path?.startsWith(path))) {
                    redirectToMaintenance();
                    return;
                }
                // Normal flow - call the original onSelection
                originalOnSelection(selection);
            };
        };
        const maintenanceAwareOnSelection = handleNavSelection(onSelection, hasWorklistMaintenanceWindow);
        const logout = ()=>{
            const orgCode = context.activeContext?.organizationCode ?? '';
            this.props.logout(orgCode);
        };
        const activeOrgDisplay = context.activeContext?.shortDisplayName && context.activeContext?.shortDisplayName !== '' ? context.activeContext?.shortDisplayName : context.activeContext?.displayName && context.activeContext?.displayName !== '' ? context.activeContext?.displayName : context.activeContext?.organizationCode && context.activeContext?.organizationCode !== '' ? context.activeContext?.organizationCode : '';
        const appContents = awaitingTokenTransfer || awaitingResources ? /*#__PURE__*/ _jsx(SwitchingContext, {
            context: context,
            changingContext: loading
        }) : /*#__PURE__*/ _jsxs(Keypress, {
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    id: "appRoot",
                    "data-testid": "app-root",
                    className: classnames(styleClasses),
                    children: [
                        loadingState?.isLoading && /*#__PURE__*/ _jsx("div", {
                            className: "centered-application",
                            children: /*#__PURE__*/ _jsx("div", {
                                className: "centered-application-wrapper",
                                children: /*#__PURE__*/ _jsx(LoadingOverlay, {
                                    loadingMsg: loadingState?.loadingMsg
                                })
                            })
                        }),
                        ' ',
                        noActiveContext && /*#__PURE__*/ _jsx("div", {
                            className: "centered-application choice-view",
                            children: /*#__PURE__*/ _jsx("div", {
                                className: "centered-application-wrapper",
                                children: /*#__PURE__*/ _jsx(ContextChoiceForm, {
                                    context: context && context.activeContext,
                                    handleOrganizationChoice: handleOrganizationChoice,
                                    contexts: contexts,
                                    user: activeUser
                                })
                            })
                        }),
                        noEulaAcceptance && !noActiveContext && /*#__PURE__*/ _jsx(Eula, {}),
                        feedback && /*#__PURE__*/ _jsx(Toast, {
                            feedback: feedback,
                            status: feedback.meta?.level
                        }),
                        /*#__PURE__*/ _jsx("span", {
                            children: modal && /*#__PURE__*/ _jsx(LogoutModal, {
                                ...modal
                            })
                        }),
                        /*#__PURE__*/ _jsx("span", {
                            children: accountSettingsIsOpen && !modal && /*#__PURE__*/ _jsx(AccountSettings, {})
                        }),
                        /*#__PURE__*/ _jsx("span", {
                            children: capturedTimeIsOpen && !modal && /*#__PURE__*/ _jsx(CapturedTime, {
                                listCapturedTime: listCapturedTime,
                                listProtectedTime: listProtectedTime,
                                deleteProtectedTimeEntry: deleteProtectedTimeEntry,
                                updateProtectedTimeEntry: updateProtectedTimeEntry,
                                addProtectedTimeEntry: addProtectedTimeEntry,
                                getMaxAllowedBackdate: getMaxAllowedBackdate,
                                listStatus: listStatus,
                                user: activeUser,
                                context: context
                            })
                        }),
                        isNewFlow || atGradingScreen ? this.props.showSideNavBar ? /*#__PURE__*/ _jsx("nav", {
                            className: "layout-navbar",
                            children: /*#__PURE__*/ _jsx(PrimaryGlobalNavigation, {
                                actionGroups: actionGroups,
                                activeOrg: activeOrgDisplay,
                                activeUser: activeUser,
                                onSelection: maintenanceAwareOnSelection,
                                handleOrganizationChoice: handleOrganizationChoice,
                                handleServiceLineChoice: handleServiceLineChoice,
                                context: context,
                                onLogout: logout,
                                serviceLine: serviceLine,
                                openAccountSettings: openAccountSettings,
                                openCapturedTime: openCapturedTime,
                                listStatus: listStatus,
                                updateStatus: updateStatus,
                                showDashboardOptions: showDashboardOptions,
                                getSubNavPaths: getSubNavPaths
                            })
                        }) : null : /*#__PURE__*/ _jsx("nav", {
                            className: "layout-navbar",
                            children: /*#__PURE__*/ _jsx(PrimaryGlobalNavigation, {
                                actionGroups: actionGroups,
                                activeOrg: activeOrgDisplay,
                                activeUser: activeUser,
                                onSelection: maintenanceAwareOnSelection,
                                handleOrganizationChoice: handleOrganizationChoice,
                                handleServiceLineChoice: handleServiceLineChoice,
                                context: context,
                                onLogout: logout,
                                serviceLine: serviceLine,
                                openAccountSettings: openAccountSettings,
                                openCapturedTime: openCapturedTime,
                                listStatus: listStatus,
                                updateStatus: updateStatus,
                                showDashboardOptions: showDashboardOptions,
                                getSubNavPaths: getSubNavPaths
                            })
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "layout-main",
                            style: mainStyle,
                            children: !noRoutes && /*#__PURE__*/ _jsxs("main", {
                                className: "content-container min-dimensions",
                                style: {
                                    padding: 0
                                },
                                children: [
                                    /*#__PURE__*/ _jsx(CaseCancellationComponent, {}),
                                    /*#__PURE__*/ _jsx(InvoiceEditorComponent, {}),
                                    /*#__PURE__*/ _jsx(CMXDrawer, {}),
                                    /*#__PURE__*/ _jsx(PatientTimeline, {}),
                                    /*#__PURE__*/ _jsx(ProviderDetails, {}),
                                    /*#__PURE__*/ _jsx(CoderNotes, {}),
                                    /*#__PURE__*/ _jsx(CreateCase, {}),
                                    /*#__PURE__*/ _jsx(MergeCasesModal, {}),
                                    /*#__PURE__*/ _jsx(AttachDocsModal, {}),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: isNewFlow ? '' : 'layout-full layout-inner-body',
                                        children: [
                                            /*#__PURE__*/ _jsx(Route, {
                                                path: "/cmx/cases/:serviceLine/:id?",
                                                exact: true,
                                                component: CaseListAndDetail
                                            }),
                                            /*#__PURE__*/ _jsx(Route, {
                                                path: [
                                                    '/cmx/analytics/',
                                                    '/cmx/cases/'
                                                ],
                                                exact: true,
                                                component: ServiceLineMessage
                                            }),
                                            /*#__PURE__*/ _jsx(Route, {
                                                path: "/cmx/tableau/",
                                                exact: true,
                                                component: TableauDashboard
                                            }),
                                            /*#__PURE__*/ _jsx(Route, {
                                                exact: true,
                                                path: [
                                                    `${CQA_QUALITY_ASSESSMENT_GRADING_SCREEN}/:id/`
                                                ],
                                                component: ConnectedServiceDeskAndGradeBench
                                            }),
                                            /*#__PURE__*/ _jsx(Route, {
                                                exact: true,
                                                path: [
                                                    '/cmx/worklist/:serviceLine/case/:caseId/case-run/:id/',
                                                    '/cmx/worklist/:serviceLine/case/:caseId/case-run/:id/v2/',
                                                    '/cmx/worklist'
                                                ],
                                                component: this.getMaintenanceWrappedComponent(ConnectedServiceDeskAndCodeBench, hasWorklistMaintenanceWindow || false)
                                            }),
                                            /*#__PURE__*/ _jsx(Route, {
                                                path: [
                                                    '/cmx/coding-quality/:serviceLine/case/:caseId/case-run/:id/',
                                                    '/cmx/coding-quality/:serviceLine/case/:caseId/case-run/:id/v2/',
                                                    '/cmx/coding-quality'
                                                ],
                                                exact: true,
                                                component: this.getMaintenanceWrappedComponent(ConnectedServiceDeskAndCodeBench, hasWorklistMaintenanceWindow || false)
                                            }),
                                            /*#__PURE__*/ _jsx(Route, {
                                                path: "/cmx/quality-assessment",
                                                exact: true,
                                                component: QualityAssessment
                                            }),
                                            /*#__PURE__*/ _jsx(Route, {
                                                path: "/cmx/queue-settings",
                                                component: this.getMaintenanceWrappedComponent(QueueSettings, hasWorklistMaintenanceWindow || false),
                                                exact: true
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                style: {
                                                    maxWidth: '100%',
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    flex: (this.props.pathname ?? '').startsWith('/cmx/admin') ? '1 1 0' : '0 0 0',
                                                    minHeight: 0
                                                },
                                                className: "max-dimensions",
                                                children: /*#__PURE__*/ _jsx(Route, {
                                                    path: "/cmx/admin/",
                                                    children: /*#__PURE__*/ _jsx(AdminTemplate, {
                                                        title: "Admin",
                                                        items: AdminTabs,
                                                        onSelection: this.handleAdminTabSelect
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx(Route, {
                                                path: "/cmx/provider_directory/",
                                                exact: true,
                                                component: ProviderDirectoryFrame
                                            }),
                                            /*#__PURE__*/ _jsx(Route, {
                                                path: "/cmx/",
                                                exact: true,
                                                children: !hasResources && /*#__PURE__*/ _jsxs(Card, {
                                                    className: "content-vacant",
                                                    "data-testid": "content-vacant",
                                                    children: [
                                                        /*#__PURE__*/ _jsx(BiomeIcon, {
                                                            iconName: IconName.Checkbox,
                                                            iconClass: "check-box",
                                                            titleText: "Checkbox"
                                                        }),
                                                        /*#__PURE__*/ _jsx("h2", {
                                                            children: /*#__PURE__*/ _jsx("b", {
                                                                children: "Successful authentication"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsx("h4", {
                                                            children: "Please contact CodaMetrix if you require assistance setting up an HL7 interface."
                                                        }),
                                                        /*#__PURE__*/ _jsx("p", {
                                                            children: " support@codametrix.com "
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "layout-fullscreen-portal",
                            id: "fullscreenPortal"
                        }),
                        /*#__PURE__*/ _jsx(GitTag, {})
                    ]
                }),
                /*#__PURE__*/ _jsx(LocationEffect, {
                    onLocationChange: handleLocationChange
                })
            ]
        });
        return /*#__PURE__*/ _jsx(ChakraProvider, {
            theme: theme,
            children: appContents
        });
    }
    constructor(props){
        super(props), _define_property(this, "registerActivity", void 0), _define_property(this, "maintenanceWrappedComponents", new Map()), _define_property(this, "cachedMaintenanceFlag", undefined);
        this.handleDismissFeedback = this.handleDismissFeedback.bind(this);
        this.registerActivity = ()=>{
            setIsActive(true);
            /**
       * Transmitting child window activity on any of window to remaining all windows
       * to keep the session alive.       *
       */ const message = {
                type: commonActions.AuthenticatedWindow.ACTIVITY,
                payload: true,
                meta: {
                    suppressRedux: true
                }
            };
            authenticationChannel.postMessage(message);
        };
        this.handleAdminTabSelect = this.handleAdminTabSelect.bind(this);
    }
}
_define_property(CMx, "defaultProps", {
    actionGroups: [],
    roles: [],
    hasResources: false,
    context: StubContext,
    contexts: [],
    activeUser: USER_STUB,
    caseLoadState: {
        loading: false,
        error: false,
        initial: false
    },
    awaitingTokenTransfer: false,
    phiMask: {
        active: false,
        available: false
    },
    dismissFeedback: (message)=>{},
    onSelection: (selction)=>{},
    onLoad: (navData)=>{},
    selectAdminTab: (navPath, activeSubAction, navActionGroup)=>{}
});
export default CMx;
